import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
import { brand, offer } from '../data/content';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
}
const base = 'group inline-flex items-center justify-center gap-2.5 text-balance rounded-2xl text-center font-bold tracking-tight transition-[transform,background-color,box-shadow,color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold/60 active:translate-y-px';
const sizes = {
  md: 'px-5 py-3.5 text-sm sm:px-6',
  lg: 'px-4 py-4 text-[15px] sm:px-8 sm:text-base md:text-lg',
  xl: 'px-4 py-5 text-[15px] sm:px-8 sm:text-lg md:text-xl'
};
const variants = {
  primary: 'bg-wine-cta text-white shadow-cta hover:bg-wine-cta-hover',
  secondary: 'bg-ivory text-wine shadow-soft hover:bg-parchment'
};
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = '#planes',
  className = ''
}: CtaButtonProps) {
  const isCheckout = href.startsWith('http');
  const handleClick = () => {
    if (isCheckout) {
      trackPixelEvent('InitiateCheckout', {
        content_name: brand.name,
        value: offer.priceValue,
        currency: 'USD'
      });
    }
  };
  return <a href={href} onClick={handleClick} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-27" data-mp="3ow9zu70idpm8">
      <span data-id="element-28" data-mp="3swar4s8phvap">{children}</span>
      <ArrowRightIcon className="hidden h-5 w-5 shrink-0 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-29" data-mp="3svitlbvjtnhs" />
    </a>;
}